import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { useHistory } from 'react-router-dom';
import TransferTypeResourceSummaryCard from './TransferTypeResourceSummaryCard';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    marginBottom: theme.spacing(3.5),
  },
  transferTypes: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.facet.backgroundGray,
  },
}));

export default function AccountTransferSetupSelectTransferTypeTemplate() {
  const { pageContentResource: resource, loadPageContentLink } = usePageContentContext();
  const history = useHistory();
  const classes = useStyles();

  function handleSelectTransferType({ action }) {
    loadPageContentLink(action.link);
  }

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  // TODO (AY): wrap cards
  return (<>
    <Box className={classNames(classes.root)}>
      <FDContentContainer>
        <WizardStandardHeader
          color={'primary'}
          title={resource.attr('moduleName')}
          onClose={onClose}
        />
        <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} />
        <FDStack spacing={3} flex={1} wrap className={classes.transferTypes}>
          {resource.attr('transferTypes').resources().list().map(transferType => (<TransferTypeResourceSummaryCard
            onClick={handleSelectTransferType}
            key={transferType.id()}
            resource={transferType}
          />))}
        </FDStack>
      </FDContentContainer>
    </Box>
  </>);
}
